import { i18nClient } from '@sailor/i18n-web'

// 定义员工状态枚举
export enum StaffStatus {
  LEAVE = 1, // 离职
  ACTIVE = 2, // 在职
}

export const staffStatusOptions = {
  '1': { i18nKey: 'e_pc_leave', value: 1, label: i18nClient.getText('e_pc_leave', '离职') },
  '2': { i18nKey: 'e_pc_employed', value: 2, label: i18nClient.getText('e_pc_employed', '在职') },
}

// 交易类型枚举
export enum TransactionTypeEnum {
  PAY = 10, // 支付
  REFUND = 20, // 退款
  RECHARGE = 30, // 充值
  ADJUSTMENT = 40, // 调账
  WITHDRAW = 50, // 提现
  CREDIT = 60, // 授信调整
}

// 合作模式枚举（结算模式）
export enum CooperateModeEnum {
  PRE_CHARGE = 'preCharge', // 预充值
  AFTER_SETTLEMENT = 'afterSettlement', // 后结算
}
// 定义订单下载类型枚举
export enum OrderDownloadType {
  ORDER_RECEIPT = 1, // 订单收据
}
